module.exports = __webpack_public_path__ + "media/images/emblems/Ogens-coat_of_arms-6a93a1ac341566f65b0eed06c566f21a.svg";